module.exports = {

  "pleaseWait":'කරුණාකර රැඳී සිටින්න',
  loading:'පූරණය වෙමින් පවතී',
  Billing:'බිල්පත්',
  billingTips:'ඔබගේ මිලදී ගැනීම් ඉතිහාසය',
  ID:'අංකය',
  FAQ:'නිතර අසන ප්‍රශ්න',
  TC:'නියම සහ කොන්දේසි',
  Copyright:'© 2025 සියලුම හිමිකම් ඇවිරිණි.',
  GenerateImage:'AI චිත්‍ර නිර්මාණය',
  generateTips1:'අපගේ AI රූප නිර්මාණකය මඟින් ඔබගේ පරිකල්පනය යථාර්ථයක් බවට පත් කරමින් තත්පර කිහිපයකින් අලංකාර චිත්‍ර, නිදර්ශන සහ ඡායාරූප නිර්මාණය කරයි. AI හි බලය භාවිතයෙන් ඔබගේ නිර්මාණශීලීත්වය මුදාහරිමින් නව ආකාරවලින් ඔබව ප්‍රකාශ කරන්න. අද්විතීය අලෙවිකරණ ද්‍රව්‍ය නිර්මාණය කිරීමේ සිට අලංකාර කලා නිර්මාණ සෑදීම දක්වා අසීමිත හැකියාවන් පහසුවෙන් සහ කාර්යක්ෂමව අත්විඳින්න.',
  generateTips2:'පහතින් වචන කිහිපයක් ඇතුළත් කර, beautiGen මඟින් පෙළ විශිෂ්ට කලා නිර්මාණයක් බවට පත් කරන ආකාරය බලන්න.',
  Prompt:'විස්තරය',
  PromptTips1:'අඳින්න අවශ්‍ය දේ AI වෙත කියන්න.',
  PromptTips2:'ඉඟිය: මනෝභාවය සහ ආලෝකය විස්තර කරන්න. වැඩි විස්තර සඳහා පිටුවේ ඇති ඉඟි බලන්න.',
  PromptTips3:'සටහන: AI විසින් උපදෙස් සම්පූර්ණයෙන් අනුගමනය නොකළ හැකි අතර ගණන් කළ නොහැක.',
  Generate:'නිර්මාණය කරන්න',
  ChancesLeft:'ඉතිරි අවස්ථා',
  BuyChances:'තවත් අවස්ථා මිලදී ගන්න',
  generateImageTips1:'ඔබට අවශ්‍ය දේ ඇතුළත් කරන්න',
  generatePromptsTips1:'ඔබට අවශ්‍ය නොවන දේ ඇතුළත් කරන්න',
  indexTips1:'දෛනික නොමිලේ අවස්ථාව <br /> ලබා ගත හැක!',
  indexTips2:'මේවායින් එකක් තෝරන්න',
  ImageRestorer:'රූප ප්‍රතිසංස්කරණය',
  Continue:'ඉදිරියට යන්න',
  language0:'භාෂාව',
  language:'භාෂාව තෝරන්න',
  languageTips:'ඔබගේ භාෂාව මෙහි තෝරන්න',
  Submit:'ඉදිරිපත් කරන්න',
  change:'වෙනස් කරන්න',
  English:'ඉංග්‍රීසි',
  Myanmar:'මියන්මාර',
  Login:'ඇතුල් වන්න',
  Logout:'පිටවන්න',
  getCode:'යවන්න',
  loginTips:'ඔබගේ දුරකථන අංකය ඇතුළත් කරන්න',
  otpTips:'කරුණාකර OTP ඇතුළත් කරන්න',
  profile:'පැතිකඩ',
  phoneNumber:'දුරකථන අංකය',
  SubscribedSince:'දායක වූ දිනය',
  RemainingChances:'ඉතිරි අවස්ථා',
  cgtips2:'දිනකට 149 Ks පමණි,<br />දායක වීමට OK ක්ලික් කරන්න.',
  cgtips2W:'සතියකට 599 Ks පමණි,<br />දායක වීමට OK ක්ලික් කරන්න.',
  cgtips2M:'මාසයකට 1999 Ks පමණි,<br />දායක වීමට OK ක්ලික් කරන්න.',
  OK:'OK',
  PictureRestorer:'ඡායාරූප ප්‍රතිසංස්කරණය',
  PictureTips1:'AI භාවිතයෙන් ඡායාරූප ප්‍රතිසංස්කරණය, පැහැදිලි කිරීම සහ අලුත්වැඩියා කිරීම සිදු කරන්න. නවතම තාක්ෂණය භාවිතයෙන් beautiGen සීරීම් ස්වයංක්‍රීයව ඉවත් කර, වර්ණ පැහැදිලි කර, මුහුණු වැඩිදියුණු කරයි. එමඟින් හානි වූ ඡායාරූප වටිනා මතකයන් බවට පත් කරයි. අපගේ නොමිලේ සේවාව වර්ණ ඡායාරූප මෙන්ම කළු-සුදු ඡායාරූපද ප්‍රතිසංස්කරණය කරයි.',
  Upload:'උඩුගත කරන්න',
  PictureTips2:'සීරීම් තිබේද?',
  Restore:'ප්‍රතිසංස්කරණය කරන්න',
  uploadTips:'කරුණාකර ඡායාරූප උඩුගත කරන්න',
  PurchaseChances:'අවස්ථා මිලදී ගන්න',
  History:'ඉතිහාසය',
  purchaseTips1:'ඔබගේ මුළු අවස්ථා',
  purchaseTips2:'එක් වරක් මිලදී ගැනීම',
  Daily:'දෛනික',
  Weekly:'සතිපතා',
  OneTime:'එක් වරක්',
  Purchase:'මිලදී ගන්න',
  DailyKyats:'149 Kyats',
  WeeklyKyats:'599 Kyats',
  OneTimeChance:'129 Ks/අවස්ථාවක්',
  Subscribe:'දායක වන්න',
  purchaseTips3:'තවත් එක් අවස්ථාවක් මිලදී ගැනීමට Buy Now ක්ලික් කරන්න',
  BuyNow:'දැන් මිලදී ගන්න',
  comingsoonT:'ඉක්මනින් පැමිණේ',
  logout:'පිටවන්න',

  petTitle1:'AI සුරතල් සතුන් Anime',
  petTitle2:'විලාසය තෝරන්න',
  petContent1:'ඔබගේ ආදරණීය සුරතලාගේ ඡායාරූපය ආකර්ෂණීය Anime ආකාරයේ විශිෂ්ට නිර්මාණයක් බවට පත් කරයි. සුරතල් සතුන්ට ආදරය කරන අයට සහ Anime රසිකයින්ට පරිපූර්ණ වන beautiGen, ඔබගේ ආදරණීය සුරතල් මිතුරන් සැමරීමට විනෝදජනක සහ පුද්ගලීකරණය කළ ක්‍රමයක් ලබා දෙයි.',
  sexTitle1:'Anime චිත්‍ර',
  sexTitle2:'ස්ත්‍රී/පුරුෂ භාවය තෝරන්න',
  sexContent1:'ලියන ලද විස්තර මත පදනම්ව Anime ආකාරයේ ඡායාරූප නිර්මාණය කරමින් ඔබගේ පරිකල්පනය යථාර්ථයක් බවට පත් කරයි. ඔබ Anime රසිකයෙකු, කතන්දර රචකයෙකු හෝ නිර්මාණකරුවෙකු වුවද, AI Anime Photo මඟින් උසස් තත්ත්වයේ, වර්ණවත් Anime ආකාරයේ දෘශ්‍ය නිර්මාණ පහසුවෙන් සෑදීමට ඔබට හැකියාව ලබා දෙයි.',
  sexContent2:'beautiGen මඟින් පෙළ විශිෂ්ට කලා නිර්මාණයක් බවට පත් කරන ආකාරය බලන්න.',
  Female:'කාන්තා',
  Male:'පිරිමි',
  Style1:'විලාසය 1',
  Style2:'විලාසය 2',
  Style3:'විලාසය 3',
  Comic:'කොමික්',
  Disney:'Disney',
  Ghibli:'Ghibli',
  Animalanime:'Selfie Anime',
  HumanAnime:'Human Anime',
  Guidance:'මාර්ගෝපදේශය',
  PetAnime:'Pet Anime',

  landTips1:'විශිෂ්ට ඡායාරූප නිර්මාණය කර',
  landTips2:'විශාල ත්‍යාග දිනා ගන්න!',
  landTips3:'beautiGen සමඟ ඔබගේ පරිකල්පනය යථාර්ථයක් බවට පත් කරන්න! විශිෂ්ට ඡායාරූප නිර්මාණයේ සිට කලාත්මක විශිෂ්ට නිර්මාණ දක්වා beautiGen මඟින් වෙන කවරදාටත් වඩා අපූරු දෘශ්‍ය නිර්මාණ කිරීමට ඔබට හැකියාව ලබා දෙයි. සීමා රහිත හැකියාවන්ගෙන් පිරි ලෝකයකට පිවිසෙන්න.',
  show401tip:'ප්‍රමාණවත් ශේෂයක් නොමැත',
  show400dailytip:'කාලය අවසන්. විශාල ත්‍යාගය දිනා ගැනීමට 548 වෙත "ON1" යවන්න.',
  show400weeklytip:'කාලය අවසන්. විශාල ත්‍යාගය දිනා ගැනීමට 548 වෙත "ON7" යවන්න.',
  register:'ලියාපදිංචි වන්න',
  invitation:'ආරාධනාව',
  invitationTips:'පහත සබැඳිය භාවිතයෙන් ආරාධනාව පිටපත් කර යවන්න',
  InviteNow:'දැන් ආරාධනා කරන්න',
  copySuccess:'පිටපත් කිරීම සාර්ථකයි!',
  process:'නිර්මාණය වෙමින් පවතී',
  downTips1:'කරුණාකර සබැඳිය බ්‍රවුසරයට පිටපත් කර බාගත කරන්න.',
  copyLink:'සබැඳිය පිටපත් කරන්න',

  ChangeHairstyle:'කේශ විලාසිතා මැජික්',
  ChangeHairstyle_content_1:'beautiGen යෙදුම මඟින් කේශ විලාසිතා වෙනස් කිරීමේ පහසුකම ලබා දෙන අතර, පරිශීලකයින්ට විවිධ කේශ විලාසිතා සැබෑ කාලයේදී හෝ උඩුගත කළ ඡායාරූප භාවිතයෙන් අත්හදා බැලිය හැක. මෙම පහසුකම AI තාක්ෂණය භාවිතයෙන් පරිශීලකයාගේ මුහුණේ ලක්ෂණ විශ්ලේෂණය කර, ඔහුගේ හෝ ඇයගේ මුහුණේ හැඩය, කැමැත්ත සහ විලාසයට ගැළපෙන කේශ විලාසිතා යෝජනා කරයි. සරල වෙනස්කම්වල සිට කැපී පෙනෙන වෙනස්කම් දක්වා විවිධ පෙනුම් අත්හදා බැලීමට පරිශීලකයින්ට හැකි අතර, සැබෑ වෙනසක් කිරීමට පෙර එය අතථ්‍යව දැකගත හැක. විවිධ කේශ විලාසිතා සොයා බැලීමට සහ තමන්ට ගැළපෙන පරිපූර්ණ විලාසය තෝරා ගැනීමට මෙය පහසු සහ විනෝදජනක ක්‍රමයකි.',
  ChangeHairstyle_content_2:'පහතින් ඔබ කැමතිම කේශ විලාසිතාව තෝරා ඔබගේම ඡායාරූපයක් එක් කරන්න. ඔබට අලංකාර සහ පැහැදිලි ඡායාරූපයක් ලැබෙනු ඇත.',

  SmartCutout:'පසුබිම මකනය',
  SmartCutout_content:'beautiGen හි Background Remove පහසුකම මඟින් AI තාක්ෂණයේ නිරවද්‍යතාවයෙන් ඕනෑම රූපයක පසුබිම පහසුවෙන් ඉවත් කිරීමට හෝ වෙනස් කිරීමට පරිශීලකයින්ට හැකිය. වෘත්තීය නිෂ්පාදන ඡායාරූප, විනෝදජනක සමාජ මාධ්‍ය පළ කිරීම් හෝ කලාත්මක සංස්කරණ නිර්මාණය කළද, එක් ස්පර්ශයකින් පිරිසිදු සහ සුමට ලෙස පසුබිම ඉවත් කිරීමට මෙම මෙවලම උපකාරී වේ.',

  IpIMage:'හැඳුනුම්පත් ඡායාරූපය',
  IpIMage_content:'හැඳුනුම්පත් ඡායාරූපය සඳහා උඩුගත කරන මුල් ඡායාරූපයේ පුද්ගලයාගේ මුහුණ පැහැදිලිව පෙනෙන අතර කිසිදු බාධාවක් නොතිබිය යුතුය. එසේම උරහිස් සමාන මට්ටමක තිබිය යුතුය. එසේ නොමැති නම් නිර්මාණය අසාර්ථක විය හැක.',

  landfont3:'ඔබගේ පරිකල්පනයෙන් රූප නිර්මාණය කරන්න',
  landfont1:'ඔබගේ ඡායාරූපය Anime රූපයක් බවට පත් කරන්න',
  landfont2:'ඔබගේ ඡායාරූපයෙන් පසුබිම ඉවත් කරන්න',
  landfont4:'ඔබ සිතන කේශ විලාසිතා නිර්මාණය කර අත්හදා බලන්න',
  landfont5:'ඔබගේ ඡායාරූපය හැඳුනුම්පත් ඡායාරූපයක් බවට පත් කරන්න',

  select:'තෝරන්න',
  Monthly:'මාසික',
  landFree:'මැයි 10 සිට ජුනි 10 දක්වා නොමිලේ',
  free:'නොමිලේ',

  snapbot:'BtgenBot',
  snapbot_hi:'ආයුබෝවන්, මම BtgenBot',
  snapbotTips1:'වේගවත් සෙවුම් ප්‍රතිඵල',
  snapbotTips2:'ස්වාභාවික භාෂා සැකසීම',
  snapbotTips3:'විශාල දත්ත විශ්ලේෂණය',
  snapbotTips4:'AI මගින් බලගැන්වූ ඇල්ගොරිතම',
  snapbotInput1:'BtgenBot සමඟ ආරම්භ කිරීමට මෙහි තට්ටු කරන්න',
  help_today:'අද මම ඔබට උපකාර කරන්නේ කෙසේද?',
  think_ip:'🤖 සිතමින්...',
  white:'සුදු',
  blue:'නිල්',
  '1 inch':'අඟල් 1',
  '2 inches':'අඟල් 2',
  '3 inches':'අඟල් 3',
  re_sub_tip:'ඔබ දායකත්වය අවලංගු කර තිබේද?',
  subscribe:'දායක වන්න',
  login_tip_2:'දින 7ක නොමිලේ අත්හදා බැලීමක් භුක්ති විඳින්න සහ සෑම අලුත් කිරීමකදීම ATOM Star Points 30ක් ලබා ගන්න',
  redirect_tip:'ඔබ බ්‍රවුසරය වෙත යොමු කරනු ඇත.',
  UNSUBSCRIBE:'දායකත්වය අවලංගු කරන්න',
}



// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js